<template>
    <div class="organizer">
        <div class="organizer-container">
            <div class="title">
                <h3><em></em><span>{{ $t('organizer.title') }}</span><em></em></h3>
            </div>
            <div class="organizer-list">
                <div v-for="item in organizers" :key="item.id" class="organizer-item">
                    <router-link :to="'/organizer/' + item.id">
                        <img :src="require('@/assets/organizers/' + item.img)" alt="">
                        <p class="name">{{ t('organizer.details.' + item.id + '.name') }}</p>
                    </router-link>
                    <a :href="item.url" class="desc" target="_blank">{{ t('organizer.details.' + item.id + '.desc') }}</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { useI18n } from 'vue-i18n'

export default {
    name: 'Organizer',
    setup() {
        const i18n = useI18n()
        const { t } = i18n
        const organizers = [
            {
                id: '1',
                img: t('organizer.details.1.img'),
                name: t('organizer.details.1.name'),
                desc: t('organizer.details.1.desc'),
                url: t('organizer.details.1.url'),
            },
            {
                id: '2',
                img: t('organizer.details.2.img'),
                name: t('organizer.details.2.name'),
                desc: t('organizer.details.2.desc'),
                url: t('organizer.details.2.url'),
            },
            {
                id: '3',
                img: t('organizer.details.3.img'),
                name: t('organizer.details.3.name'),
                desc: t('organizer.details.3.desc'),
                url: t('organizer.details.3.url'),
            }
        ]
        return {
            i18n,
            t,
            organizers
        }
    }
}
</script>

<style scoped lang="scss">
.organizer {
    width: 100%;
    background-image: url('@/assets/org_bg.png');

    a {
        text-decoration: none;
    }

    .organizer-container {
        width: 100%;
        padding: 50px 0;
        display: flex;
        flex-direction: column;
        align-items: center;

        .title {
            h3 {
                font-size: 30px;
                font-weight: bold;
                text-align: center;
                color: #fff;
                margin-bottom: 60px;

                span {
                    margin: 0 40px;
                }

                em {
                    display: inline-block;
                    width: 54px;
                    height: 14px;
                    margin-bottom: 10px;
                    background: url('@/assets/ttc.png');
                    vertical-align: middle;
                }
            }
        }

        .organizer-list {
            display: flex;
            flex-wrap: wrap;
            margin-right: -10px;
            margin-left: -10px;

            .organizer-item {
                display: flex;
                flex-direction: column;
                align-items: center;

                width: 33.33%;

                img {
                    width: 280px;
                    height: 344px;
                    border-radius: 10px;
                    margin-bottom: 10px;
                }

                .name {
                    font-size: 30px;
                    font-weight: 400;
                    color: #fff;
                    text-align: center;
                    margin-bottom: 10px;

                }

                .desc {
                    font-size: 20px;
                    color: #fff;
                    text-align: center;
                    margin-bottom: 10px;

                }

            }

        }

    }


}

@media (max-width: 768px) {
    .organizer {
        background-image: url("@/assets/org_bg_mob.png");
        background-size: 100% 100%;
    }

    .organizer-container {
        padding: 30px 0;

        .title {
            em {
                margin-bottom: 0 !important;
                width: 40px !important;
            }

            span {
                font-size: 22px;
                margin: 0 10px !important;
            }
        }

        .organizer-list {
            flex-direction: column;
            align-items: center;
            margin-right: 0 !important;
            margin-left: 0 !important;

            .organizer-item {
                width: auto !important;
                padding: 0 30px;
                margin-bottom: 20px;

                img { 
                    width: 100%;
                    height: auto;
                }

                .name {
                    font-size: 24px;
                    margin-bottom: 0px !important;
                }

                .desc {
                    font-size: 16px;
                }
            }
        }
    }
}
</style>
